<script setup lang="ts">
  import { copy } from '@/functions'

  const props = defineProps<{
    text: string,
  }>()

  const copyText = () => {
    copy(props.text)
  }
</script>

<template>
  <app-button
    title="Salin"
    @click="copyText">
    <slot></slot>
  </app-button>
</template>
